<template>
  <div>
    <!-- Hero Section -->
    <section class="hero container">
      <el-carousel height="400px" indicator-position="outside" arrow="always">
        <el-carousel-item
          v-for="(item, index) in $t('home.banners')"
          :key="index"
          @click.native="goToLink(links[index])"
        >
          <div class="banner-item">
            <img :src="images[index]" class="banner-img" />
            <div class="banner-overlay">
              <h2>{{ item.title }}</h2>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- Products Section -->
    <section class="devices">
    <div class="devices-header">
      <h2>{{ $t("home.products_title") }}</h2>
    </div>

    <div class="devices-container">
      <div class="devices-wrapper">
        <!-- 左箭头 -->
        <button class="arrow-btn left" @click="scrollLeftClick">
          ‹
        </button>

        <!-- 滑动容器 -->
        <div
          class="devices-scroll"
          ref="scroll"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="stopDrag"
          @mouseleave="stopDrag"
        >
          <div
            v-for="(item, key) in deviceList"
            :key="key"
            class="device-card"
          >
            <el-card shadow="hover" class="device-card-inner">
              <img
                class="device-img"
                :src="item.img"
                :alt="$t(`home.devices.${key}.name`)"
              />
              <h3>{{ $t(`home.devices.${key}.name`) }}</h3>
              <p>{{ $t(`home.devices.${key}.desc`) }}</p>
            </el-card>
          </div>
        </div>

        <!-- 右箭头 -->
        <button class="arrow-btn right" @click="scrollRightClick">
          ›
        </button>
      </div>
    </div>
  </section>

    <!-- News Section -->
    <section class="news container">
    <h2>{{ $t("home.news_title") }}</h2>

    <el-row :gutter="20" class="news-grid">
      <el-col :xs="24" :sm="8" v-for="n in newsList" :key="n.id" style="margin-top: 10px;">
        <el-card shadow="hover" class="news-card" @click="goDetail(n.url)">
          <div class="news-content">
            <h3>{{ n.title }}</h3>
            <p class="meta">{{ n.date }}</p>
            <p class="summary clamp">{{ n.summary }}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="more-btn">
      <el-button type="primary" @click="goMore">{{ $t('home.more') }}</el-button>
    </div>
  </section>

  <!-- Company About Section -->
<section class="about container">
  <h2>{{ $t("home.about_title") }}</h2>
  <div class="about-content">
    <img src="@/assets/about.jpg" alt="About Zbecon" class="about-img" />
    <div class="about-text">
      <p>{{ $t("home.about_desc") }}</p>
    </div>
  </div>
</section>

    <!-- Contact CTA -->
    <section
      class="contact-cta"
      style="
        background: linear-gradient(90deg, #e8f5ff, #f7fbff);
        margin: auto;
        margin-top: 24px;
        max-width: 1200px;
        text-align: center;
      "
    >
      <div class="container">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
          "
        >
          <div>
            <h3>{{ $t("home.ready_title") }}</h3>
            <p>{{ $t("home.ready_desc") }}</p>
          </div>
          <div>
            <el-button
              type="primary"
              size="large"
              @click="$router.push('/contact')"
            >
              {{ $t("nav.contact") }}
            </el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      images: [
        require("@/assets/banner-1.jpg"),
        require("@/assets/banner-2.jpg"),
        require("@/assets/banner-3.jpg"),
        require("@/assets/banner-4.jpg"),
        require("@/assets/banner-5.jpg"),
      ],
      links: [
        "https://shop349sc98235401.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0",
        "https://shop349sc98235401.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0",
        "https://shop349sc98235401.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0",
        "https://shop349sc98235401.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0",
        "https://shop349sc98235401.1688.com/page/offerlist.htm?spm=a2615.2177701.wp_pc_common_topnav.0",
      ],
      deviceList: {
        socket: { img: require("@/assets/images/devices/socket.png") },
        switch: { img: require("@/assets/images/devices/switch.png") },
        gateway: { img: require("@/assets/images/devices/gateway.png") },
        humidity: { img: require("@/assets/images/devices/humidity.png") },
        dimmer: { img: require("@/assets/images/devices/dimmer.png") },
        alarm: { img: require("@/assets/images/devices/alarm.png") },
        ir_remote: { img: require("@/assets/images/devices/ir_remote.png") },
      },
      news: [],
    };
  },
  computed: {
    newsList() {
      // 从 i18n 中动态读取数组
      return this.$t("home.news");
    }
  },
  created() {
  },
  methods: {
    goDetail(url) {
      console.log(url)
      if (url) {
        window.open(url, "_blank"); // ✅ 在新标签打开第三方链接
      }
    },
    goMore() {
      this.$router.push("/news");
    },
    goToLink(link) {
      window.open(link, "_blank");
    },
     startDrag(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scroll.offsetLeft;
      this.scrollLeft = this.$refs.scroll.scrollLeft;
      this.$refs.scroll.classList.add("dragging");
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scroll.offsetLeft;
      const walk = (x - this.startX) * 1.5;
      this.$refs.scroll.scrollLeft = this.scrollLeft - walk;
    },
    stopDrag() {
      this.isDragging = false;
      this.$refs.scroll.classList.remove("dragging");
    },
    scrollLeftClick() {
      this.$refs.scroll.scrollBy({ left: -400, behavior: "smooth" });
    },
    scrollRightClick() {
      this.$refs.scroll.scrollBy({ left: 400, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.hero.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.banner-item {
  position: relative;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  cursor: pointer;
}

.banner-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 12px;
}
.banner-item::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
}
.banner-overlay {
  position: absolute;
  bottom: 40px;
  left: 40px;
  color: #fff;
  z-index: 2;
}

.banner-overlay h2 {
  font-size: 28px;
  margin-bottom: 8px;
}

.banner-overlay p {
  font-size: 16px;
}

.devices {
  padding: 60px 0;
}

.devices-header {
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding: 0 20px;
}

.devices-header h2 {
  font-size: 28px;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
}

.devices-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.devices-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.devices-scroll {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  gap: 20px;
  padding: 10px 20px;
  cursor: grab;
  user-select: none;
  scroll-snap-type: x mandatory;
  -ms-overflow-style: none;  /* IE/Edge */
  scrollbar-width: none;     /* Firefox */
}

.devices-scroll::-webkit-scrollbar {
  display: none; /* Chrome / Safari / Edge */
}

.devices-scroll.dragging {
  cursor: grabbing;
}

.device-card {
  flex: 0 0 auto;
  width: 240px;
  scroll-snap-align: start;
}

.device-card-inner {
  border-radius: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.device-card-inner:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
}

.device-img {
  width: 100%;
  height: 180px;
  object-fit: contain;
  margin-bottom: 10px;
}

.arrow-btn {
  background: white;
  border: none;
  font-size: 40px;
  color: #666;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.arrow-btn:hover {
  background: #f5f5f5;
  color: #000;
}

.arrow-btn.left {
  position: absolute;
  left: -10px;
}

.arrow-btn.right {
  position: absolute;
  right: -10px;
}

@media (max-width: 768px) {
  .arrow-btn {
    display: none;
  }
  .device-card {
    width: 200px;
  }
}

.news.container {
  max-width: 1200px;
  margin: 0 auto;
}

.news h2 {
  text-align: left;
  margin-bottom: 20px;
}

/* 🔹 使用 flex 实现等高布局 */
.news-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.el-col {
  display: flex;
}

/* 卡片样式 */
.news-card {
  flex: 1;
  width: 100%;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
}

.news-card:hover {
  transform: translateY(-5px);
}

/* 卡片内容区域自动填充 */
.news-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.news-content h3 {
  font-size: 16px;
  margin-bottom: 8px;
  color: #333;
}

.meta {
  color: #999;
  font-size: 13px;
  margin-bottom: 10px;
}

.summary {
  color: #555;
  font-size: 14px;
  flex-grow: 1;
}

/* 🔹 限制摘要文字行数，保证高度统一 */
.clamp {
  display: -webkit-box;
  display: flex; /* ✅ 兼容未来标准 */
  -webkit-box-orient: vertical;
  box-orient: vertical; /* ✅ 标准属性 */
  -webkit-line-clamp: 3;
  line-clamp: 3; /* ✅ 标准属性 */
  overflow: hidden;
}

.more-btn {
  text-align: center;
  margin-top: 30px;
}

.about {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.about h2 {
  text-align: left;
  font-size: 24px;
  margin-bottom: 20px;
}

.about-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
}

.about-img {
  width: 300px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.about-text {
  flex: 1;
  font-size: 16px;
  line-height: 1.7;
}

</style>
